export const logoTitle = "IciApart&Rooms";
